(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStockedBrands() {
    document.querySelectorAll('[data-stocked-brands]:not([data-stock-checked])').forEach(function (root) {
      root.setAttribute('data-stock-checked', '');
      var groups = new Map();
      root.querySelectorAll('[data-brand-name]').forEach(function (link) {
        var name = link.getAttribute('data-brand-name');
        if (!groups.has(name)) groups.set(name, []);
        groups.get(name).push(link);
      });
      groups.forEach(function (links, name) {
        var url = new URL(links[0].href, window.location.origin);
        url.searchParams.set('section_id', 'brand-carousel');
        var controller = new AbortController();
        var timer = window.setTimeout(function () { controller.abort(); }, 8000);
        fetch(url.toString(), { credentials: 'same-origin', signal: controller.signal })
          .then(function (response) {
            if (!response.ok) throw new Error('Brand availability unavailable');
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var result = doc.querySelector('[data-brand-stock]');
            if (!result || result.getAttribute('data-brand-vendor').toLowerCase() !== name.toLowerCase()) return;
            if (Number(result.getAttribute('data-brand-stock')) <= 0) return;
            links.forEach(function (link) { link.hidden = false; if (name.toLowerCase() === 'sony') link.href = '/pages/sony'; if (name.toLowerCase() === 'logitech') link.href = '/collections/shop-logitech?view=brand-logitech'; });
            root.hidden = false;
          })
          .catch(function () { /* Unknown or empty brands stay hidden. */ })
          .finally(function () { window.clearTimeout(timer); });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStockedBrands);
  else initStockedBrands();
  document.addEventListener('shopify:section:load', initStockedBrands);
})();

  } catch(e) { console.error(e); }
})();
})();
